import React from 'react'
import { Menu, Icon } from 'antd'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import css from './App.css'

const TopMenu = ({
  downloading,
  isSuperAdmin,
  isTopsAdmin,
  location,
  onClick,
}) => (
  <Menu
    mode="horizontal"
    theme="dark"
    selectedKeys={[location.pathname.split('/')[1]]}
    onClick={onClick}
    className={css.nav}
  >
    <Menu.Item key="dashboard">
      <NavLink to="/dashboard">Dashboard</NavLink>
    </Menu.Item>
    <Menu.Item key="add-practice">
      <NavLink to="/add-practice">
        <Icon type="plus" />
        Add Practice
      </NavLink>
    </Menu.Item>
    {isSuperAdmin && !isTopsAdmin && (
      <Menu.Item key="download">
        {downloading ? (
          <Icon type="loading" spin />
        ) : (
          <Icon type="download" />
        )}
        Download
      </Menu.Item>
    )}
    <Menu.Item key="signout">Sign Out</Menu.Item>
  </Menu>
)

TopMenu.propTypes = {
  downloading: PropTypes.bool.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default TopMenu



// WEBPACK FOOTER //
// ./src/TopMenu.js